<template>
    <!-- nav -->
    <div>
        <BNavbar toggleable="lg" variant="dark" v-b-color-mode="'dark'" sticky>
            <BNavbarBrand link :to="{name: 'dashboardsIndex'}">
                <img :src="headerLogo" class="d-inline-block align-top" style="height:30px;"
                     alt="openITCOCKPITmobile" v-b-tooltip.focus :title="version">
                <span class="d-inline-block d-lg-none d-xl-inline-block">
                    <!-- hide system name on rotated iPad and rotated 1080p screen -->
                    &nbsp;{{ systemName }}
                </span>
            </BNavbarBrand>
            <BNavbarToggle target="nav-collapse"></BNavbarToggle>
            <BCollapse id="nav-collapse" v-model="showCollapse" is-nav>
                <BNavbarNav class="me-auto" v-if="actions.length > 0">
                    <li class="nav-item" @click="showCollapse = false" v-for="action in actions">
                        <router-link class="nav-link" :to="{ name: action.routeName}">
                            <i v-bind:class="action.icon"></i>
                            {{ $t(action.title) }}
                        </router-link>
                    </li>
                </BNavbarNav>

                <BNavbarNav>
                    <li class="nav-item">
                        <BInputGroup class="me-2">
                            <template #prepend>
                                <BInputGroupText> <i class="fa-solid fa-language"></i></BInputGroupText>
                            </template>
                            <template #append>
                                <BFormSelect
                                    v-model="$i18n.locale" :options="langs" class="navbar-dark-input"
                                    @change="changeLang()"></BFormSelect>
                            </template>
                        </BInputGroup>

                   </li>

                    <li class="nav-item ps-lg-2 pe-lg-2 pt-1 pt-lg-0 pb-1 pb-lg-0">
                        <BInputGroup class="input-group-lg">
                            <template #prepend>
                                <BInputGroupText><i class="fa-regular fa-moon"></i></BInputGroupText>
                            </template>

                            <template #append>
                                <BListGroupItem class="nav-item navbar-dark-input flex-fill ps-1 navbar-switch-radius">
                                <BFormCheckbox v-model="darkTheme" switch  size="md" class="mt-2_5">
                                </BFormCheckbox>
                                </BListGroupItem>

                            </template>
                        </BInputGroup>
                    </li>
                </BNavbarNav>

                <BNavbarNav>
                    <BButton class="nav-item btn-secondary" @click="logout">
                        <i class="fa-solid fa-right-from-bracket"></i>
                        {{ $t('Logout') }}
                    </BButton>
                </BNavbarNav>

            </BCollapse>
        </BNavbar>
        <!-- end nav -->
        <!-- content! -->
        <div id="content" class="container-fluid no-padding">
            <router-view/>
            <!--<notifications position="top center" width="50%"/>-->

        </div>
        <!-- end content -->
    </div>
</template>

<script>
import {useToast} from "vue-toastification";
import {vBColorMode} from 'bootstrap-vue-next'

export default {
    data(){
        return {
            actions: [],
            permissions: {},
            loginState: false,
            darkTheme: false,
            componentKey: false,
            langs: ['de', 'en'],
            headerLogo: '',
            systemName: '',
            version: '',
            showCollapse: false,
            user: '',
        }
    },
    methods: {
        logout(){
            this.$store.commit('setState', false);
            localStorage.removeItem('status');



            axios.get('/users/logout')
                .then(response => {
                    if(response.data.type === 'success'){
                        useToast().success(response.data.message, {
                            timeout: 5000
                        });
                        this.getLogin();
                    }else{
                        useToast().error(response.data.message, {
                            timeout: 5000
                        });
                    }

                })
                .catch(error => {
                    console.log('Error: ' + error);
                });
            this.getLogin();
        },
        getLogin(){
            this.loginState = false;
            this.$store.commit('setStatuspages', false);
            this.$store.commit('setState', false);
            localStorage.removeItem('status');

            // localStorage.clear()
            // this.$store.replaceState({})
            this.actions = [];
            this.showCollapse = false;
            this.$router.push({name: 'login'});
        },
        changeLang(){
            localStorage.setItem('lang', this.$i18n.locale)
            this.showCollapse = false
        },
        createPermissions: function (permissions){
            this.$store.commit('setPermissions', permissions);
            let nagios = permissions.nagiosmodule ?? null;
            if(nagios && nagios.cmd && nagios.cmd.submit){
                this.$store.commit('setCanSubmitCommands', true);
            }
            let downtimeDelete = permissions.downtimes ?? null;
            if(downtimeDelete && downtimeDelete.delete){
                this.$store.commit('setCanDeleteDowntimes', true);
            }
            let acknowledgementsDelete = permissions.acknowledgements ?? null;
            if(acknowledgementsDelete && acknowledgementsDelete.delete){
                this.$store.commit('setCanDeleteAcknowledgements', true);
            }
        },
    },
    created(){
        this.$store.commit('setStatuspages', false);
        if(this.$root.theme === 'dark'){
            this.darkTheme = true
        }
        this.loginState = this.$store.state.status === 'true';   // "cast" to bool
        axios.post('/users/getSystemConfig.json')
            .then(response => {
                this.headerLogo = response.data.headerLogo;
                this.systemName = response.data.systemName;
                this.version = 'Mobile Version ' + response.data.mobileVersion ?? '';
            })
            .catch(error => {
                console.log('Could not fetch logo');
            });

        // User is not logged in - no actions
        //this.actions = [];

    },
    mounted(){

      /*  this.emitter.on('login-event', () => {
            if(!this.loginState) {
                this.loginState = true;
            }
        }); */
        this.user = this.$store.state.user;


    },
    watch: {
        loginState(newValue){
            // User is not logged in - no actions
            this.actions = [];

            if(this.loginState === true){
                // Query server to get all alowed actions of this user
                axios.get('/routes/getSidebar.json')
                    .then(response => {
                        this.actions = response.data.menu ?? [];
                        let permissions = response.data.permissions ?? {};
                        this.createPermissions(permissions);
                      /*  this.$store.commit('setPermissions', permissions);
                        let nagios = permissions.nagiosmodule ?? null;
                        if(nagios && nagios.cmd && nagios.cmd.submit){
                            this.$store.commit('setCanSubmitCommands', true);
                         */
                            this.actions.forEach(
                                (action) => {
                                    if(action.routeName === 'statuspagesIndex'){
                                     //   this.$root.$emit('statuspage-exist');
                                        this.emitter.emit('statuspage-exist');
                                        this.$store.commit('setStatuspages', true);

                                    }
                                });
                        //console.log(response.data)
                    })
                    .catch(error => {
                        console.log('Error: ' + error);
                    });
            }
        },
        darkTheme(newValue){
            this.showCollapse = false
            if(newValue === true){
                this.$root.theme = 'dark';
            }else{
                this.$root.theme = 'light'
            }
        }
    }
}
</script>
<style>
.mt-2_5{
    margin-top: 0.75rem!important;
}

.navbar-switch-radius {
    border-radius: var(--bs-border-radius) !important;
    border-top-left-radius: 0!important;
    border-bottom-left-radius: 0!important;
}
</style>
